import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import React from "react";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import {
  showEditFeeModal,
  showRemoveFeeModal,
} from "../../../store/financialSettings/actions";
import {
  dateHelper,
  isValidFee,
  feeTypeLabel,
} from "../../../helpers/financial_settings_helper";
import { useTextFilter } from "helpers/textFilter";

const feeSearchFields = (fee) => [fee.serviceCode, feeTypeLabel(fee.feeType)];

export const FeesList = ({ feeList, searchQuery, showEditFeeModal, showRemoveFeeModal }) => {
  const visibleFeeList = useTextFilter(feeList, feeSearchFields, searchQuery);

  return (
    <div className="table-rep-plugin">
      <div className="table-responsive mb-0" data-pattern="priority-columns">
        <Table
          id="transaction-fees"
          className="table table-striped table-bordered"
        >
          <Thead>
            <Tr>
              <Th data-priority="1">Валидна</Th>
              <Th data-priority="1">Код на услугата</Th>
              <Th data-priority="1">Вид такса</Th>
              <Th data-priority="1">Стойност на таксата</Th>
              <Th data-priority="2">Валидна от</Th>
              <Th data-priority="2">Валидна до</Th>
              <Th data-priority="3">Създадена на</Th>
              <Th data-priority="3">Обновена на</Th>
              <Th data-priority="4">Действия</Th>
            </Tr>
          </Thead>
          <Tbody>
            {visibleFeeList.map((fee) => {
              const isValid = isValidFee(fee.validFrom, fee.validTo);
              return (
                <Tr key={fee._id}>
                  <Td className={`${isValid ? "bg-success" : "bg-warning"}`}>
                    {isValid ? "Да" : "Не"}
                  </Td>
                  <Td>{fee.serviceCode}</Td>
                  <Td>{feeTypeLabel(fee.feeType)}</Td>
                  <Td>{fee.feeAmount}</Td>
                  <Td>{dateHelper(fee.validFrom, "DD/MM/YYYY")}</Td>
                  <Td>{dateHelper(fee.validTo, "DD/MM/YYYY")}</Td>
                  <Td>{dateHelper(fee.createdAt)}</Td>
                  <Td>{dateHelper(fee.updatedAt)}</Td>
                  <Td>
                    <div className="button-items">
                      <Button
                        title="Изтрий таксата"
                        color="danger"
                        type="button"
                        className="waves-effect waves-light"
                        onClick={() => {
                          showRemoveFeeModal(fee._id);
                        }}
                      >
                        <i className="bx bx-trash-alt font-size-16 align-middle"></i>
                      </Button>
                      <Button
                        title="Редактирай таксата"
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={() => {
                          showEditFeeModal(fee._id);
                        }}
                      >
                        <i className="bx bxs-edit font-size-16 align-middle"></i>
                      </Button>
                    </div>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        {/*<pre>{JSON.stringify(list, null, 2)}</pre>*/}
      </div>
    </div>
  );
};

const mapStateToProps = ({ FinancialSettings }) => {
  return FinancialSettings;
};

export default connect(mapStateToProps, {
  showEditFeeModal,
  showRemoveFeeModal,
})(FeesList);
